export const hasPermission = (user, permission) => {
    return user?.permissions?.includes(permission) || user?.is_superuser;
};

export const canApplyManualDiscount = user => Boolean(user?.is_superuser ||
    ['Manager', 'Admin', 'Administrator'].some(role => user?.groups?.includes?.(role)));
